export default {
  props: {
    infoText: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '__/__/____',
    },
    prependIcon: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: '',
    },
    allowedDates: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      menuDate: false,
      date: '',
      dateFormatBr: 'DD/MM/YYYY',
    }
  },
  computed: {
    getRules() {
      const newRulesArray = []
      newRulesArray.push(this.isValidDate())
      return newRulesArray.concat(this.rules)
    },
    computedDateFormatted: {
      get() {
        if (this.value) {
          return this.formatDate(this.value)
        }
        return ''
      },
      set(value) {
        if (value && value.length === 10) {
          const formatedDate = this.dateTransform(value)
          if (this.formatDate(formatedDate) !== this.date) {
            this.getValue = formatedDate
            this.handleDate(formatedDate)
          }
        }
      },
    },
    getValue: {
      get() {
        const regex = /^\d{4}-\d{2}-\d{2}$/m
        const regexOpt = /^\d{2}\/\d{2}\/\d{4}$/m
        if (regex.exec(this.value) === null && regexOpt.exec(this.value) === null) {
          return null
        }
        return this.value
      },
      set(value) {
        if (this.formatDate(value) !== this.date) {
          const date = this.dateBrToUs(value)
          const dateToNumber = this.transformDateToNumber(date)
          this.$emit('input', this.format ? this.$moment(dateToNumber).format(this.format) : dateToNumber)
        }
      },
    },
  },
  methods: {
    clear() {
      this.$emit('input', '')
    },
    allowedDatesMethod(val) {
      if (this.allowedDates.length <= 0) {
        return true
      }
      return this.allowedDates.indexOf(val) !== -1
    },
    handleDate(date) {
      this.date = this.formatDate(date)
    },
    formatDate(date) {
      date = this.dateBrToUs(date)
      return this.$moment(date, this.format || 'YYYY-MM-DD').format(this.format || this.dateFormatBr)
    },
    dateTransform(value) {
      return value.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1')
    },
    dateBrToUs(date) {
      if (/^\d{2}\/\d{2}\/\d{4}$/m.exec(date) !== null) {
        date = date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]
      }
      return date
    },
    transformDateToNumber(value) {
      return value.replace(/(\d{4})(\d{2})(\d{2})/, '$3$2$1')
    },
    isValidDate() {
      return (value) => {
        if (!value) return true
        const timeValue = this.$moment(value, this.dateFormatBr)
        if (!timeValue.isValid()) {
          return this.$t('invalidDate')
        }
        return true
      }
    },
  },
}
